<template>
    <LayoutDefault>
        <Webstars/>
    </LayoutDefault>
</template>

<script>
import LayoutDefault from "../layouts/LayoutDefault";
import Webstars from "../components/Sections/Webstars";

export default {
    components: {
        Webstars,
        LayoutDefault,
    },
}
</script>
